import _includes from 'lodash/includes';
import { NextRouter } from 'next/router';

import ROUTES from 'src/routes';
import { isBrowser } from 'utils/misc-utils';

export enum PageTypes {
  accountPage = 'AccountPage',
  homePage = 'HomePage',
  categoryPage = 'CategoryPage',
  brandsPage = 'BrandsPage',
  specialsPage = 'SpecialsPage',
  searchResultsPage = 'SearchResultsPage',
  checkoutPage = 'CheckoutPage',
  orderConfirmationPage = 'OrderConfirmationPage',
  productPage = 'ProductPage',
  other = 'Other',
}

export function getPageType({ pathname }: NextRouter): PageTypes | null {
  if (!isBrowser()) {
    return null;
  }
  if (_includes(pathname, ROUTES.PRODUCTS_CATEGORY)) {
    return PageTypes.categoryPage;
  }
  if (_includes(pathname, ROUTES.PRODUCT)) {
    return PageTypes.productPage;
  }
  if (_includes(pathname, ROUTES.SPECIALS)) {
    return PageTypes.specialsPage;
  }
  if (_includes(pathname, ROUTES.BRANDS)) {
    return PageTypes.brandsPage;
  }
  if (_includes(pathname, ROUTES.CHECKOUT)) {
    return PageTypes.checkoutPage;
  }
  if (_includes(pathname, ROUTES.ALL_PRODUCTS_SEARCH)) {
    return PageTypes.searchResultsPage;
  }
  if (
    pathname === ROUTES.DISPENSARY_CNAME ||
    pathname === ROUTES.EMBEDDED_MENU_CNAME ||
    pathname === ROUTES.KIOSKS_CNAME
  ) {
    return PageTypes.homePage;
  }
  if (
    _includes(pathname, ROUTES.ACCOUNT) ||
    _includes(pathname, ROUTES.ORDERS) ||
    _includes(pathname, ROUTES.PREFERENCES)
  ) {
    return PageTypes.accountPage;
  }
  return PageTypes.other;
}
